import { getObjectFromLocalStore } from "./localStore";

const IS_NEW_DESIGN_KEY = "isNewDesign";

/**
 * Returns whether the new design/UI is enabled.
 * Checks localStorage for isNewDesign (boolean or "true"/"false" string).
 */
export function getIsNewDesign(): boolean {
  const value = getObjectFromLocalStore(IS_NEW_DESIGN_KEY);
  return value === true || value === "true";
}
